import styled, { css } from 'styled-components';
import TextareaAutosize from 'react-textarea-autosize';

import {
  CustomFieldRow,
  InputLabel as FormInputLabel,
} from '+/styles/styledComponents/Form.styles';
import * as sharedInputStyles from '+/styles/reusable/inputStyles';

const focusBorder = css`
  border-bottom-color: var(--color-neutral-500);
  outline: none;
`;

const neutralBorder = css`
  border: 1px solid var(--color-neutral-300);

  &:focus,
  &:focus-visible,
  :root &:focus-visible {
    ${focusBorder};
  }
`;

export const FieldRow = styled(CustomFieldRow)`
  padding-bottom: 0.73125rem;
`;

export const MessageFieldRow = styled(FieldRow)<{ variant: 'fill' | 'capped' }>`
  ${({ variant }) =>
    variant === 'fill' &&
    css`
      flex: 1;
      min-height: 0;
    `}
`;

export const InputLabelText = styled.span`
  ${sharedInputStyles.inputLabelTextFloatingStart};
  position: relative;
  margin-bottom: 0.5rem;
  font-size: 0.8125rem;
  font-weight: 800;
  opacity: 1;
`;

export const SubjectInput = styled.input`
  ${sharedInputStyles.textyInput};
`;

export const InputLabel = styled(FormInputLabel)`
  display: flex;
  flex-direction: column;

  /* Specificity needed to override \`:root *\` */
  ${SubjectInput} {
    ${neutralBorder};
  }
`;

export const TextAreaContainer = styled.div<{ variant: 'fill' | 'capped' }>`
  ${sharedInputStyles.textarea};
  ${neutralBorder};

  overflow-y: auto;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    background-color: rgba(0, 0, 0, 0.05);
    width: 10px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.2);
  }

  &:focus-within {
    ${focusBorder};
  }

  ${({ variant }) =>
    variant === 'fill'
      ? css`
          flex: 1;
        `
      : css`
          max-height: 20em;
        `}
`;

export const Intro = styled.div`
  color: var(--color-form-message-into-outro-text);
  text-align: left;
  margin-bottom: 1.2rem;
`;

export const TextArea = styled(TextareaAutosize)`
  width: 100%;
  overflow: hidden;
  resize: none;
  background: none;
  line-height: 1.4;
  color: var(--color-neutral-800);

  &::placeholder {
    color: var(--color-neutral-400);
  }

  &:focus,
  &:focus-visible,
  :root &:focus-visible {
    outline: none;
  }
`;

export const Outro = styled.div`
  color: var(--color-form-message-into-outro-text);
  white-space: pre-line;
  text-align: left;
  margin-top: 0.7rem;
`;
